import { Helmet } from "react-helmet-async";

const BASE_URL = "https://www.bevilacquastudiolegale.it";
const SITE_NAME = "Studio Legale Bevilacqua";
const DEFAULT_OG_IMAGE = `${BASE_URL}/images/studio-bevilacqua.jpeg`;

function SEO({
  title,
  description,
  canonical = "/",
  noindex = false,
  ogType = "website",
  ogImage = DEFAULT_OG_IMAGE,
}) {
  const canonicalUrl = `${BASE_URL}${canonical}`;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={noindex ? "noindex, follow" : "index, follow"} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="it_IT" />
      <meta property="og:site_name" content={SITE_NAME} />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
}

export default SEO;
